/**
 * Tenant identifier helpers.
 */

import type { Tenant } from '../types/tenant.types'

export function getTenantUpdateId(tenant: Tenant): string {
  const documentId = typeof tenant.documentId === 'string' ? tenant.documentId.trim() : ''
  return documentId.length > 0 ? documentId : tenant.id
}
